import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-auth`

let api = {
  // 获取列表
  getList: `${baseUrl}/messagePushConfiguration/getList`,

  // 获取列表
  gePage: `${baseUrl}/messagePushConfiguration/getPage`,

  // 详情
  getByCode: `${baseUrl}/messagePushConfiguration/getByCode`,

  // 修改
  saveOrUpdate: `${baseUrl}/messagePushConfiguration/saveOrUpdate`,

  // banner
  addAppletBanner: `${baseUrl}/appletBanner/add`,

  // banner
  updateAppletBanner: `${baseUrl}/appletBanner/update`,

  // banner
  getAppletBannerList: `${baseUrl}/appletBanner/geList`,

  // banner
  getAppletBannerByCode: `${baseUrl}/appletBanner/getByCode`,

  // banner
  deleteAppletBannerByCodes: `${baseUrl}/appletBanner/deleteByCodes`,

  // 上传图片
  uploadImg: `${baseUrl}/yqNews/uploadImg`,

  // 查询导航栏配置
  getAppletShowConfig: `${baseUrl}/appletShowConfig/get`,

  // 修改导航栏配置
  saveOrUpdateAppletShowConfig: `${baseUrl}/appletShowConfig/saveOrUpdate`,

  // 查询审批配置
  getFlowByType: `${baseUrl}/flow/getByType`,

  // 修改审批配置
  updateFlowByType: `${baseUrl}/flow/update`,

  // 获取账户列表
  getAccountList: `${baseUrl2}/account/getList`,

  // 获取人脸配置
  getPersonPicConfig: `${baseUrl}/personPicConfig/getPersonPicConfig`,

  // 修改人脸配置
  updatePersonPicConfig: `${baseUrl}/personPicConfig/saveOrUpdate`,

  // 添加boss看板权限
  addBossPerson: `${baseUrl}/bossConfig/addPerson`,

  // 查询boss看板权限分页
  getBossPageAuthorizer: `${baseUrl}/bossConfig/getPageAuthorizer`,

  // 删除boss看板权限
  deleteBossAuthorizer: `${baseUrl}/bossConfig/deleteAuthorizer`,

  // 获取人员列表
  getResponsiblePerson: `${baseUrl}/person/getResponsiblePersonList`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/ConfigManagement.js